export const initialEnvelopes = [
  { id: 1, name: 'Groceries / Sustenance', spent: 450, target: 600, colorClass: 'from-emerald-400 to-emerald-600' },
  { id: 2, name: 'Power & Utilities', spent: 180, target: 200, colorClass: 'from-bb-accent to-blue-600' },
  { id: 3, name: 'Transport Fuel', spent: 125, target: 120, colorClass: 'from-amber-400 to-amber-600' },
  { id: 4, name: 'Recreation', spent: 80, target: 150, colorClass: 'from-purple-400 to-purple-600' },
  { id: 5, name: 'Home Maintenance', spent: 45, target: 100, colorClass: 'from-pink-400 to-pink-600' },
];

export const upcomingBills = [
  { id: 1, name: 'Grid Power Corp', amount: 120.50, date: 'OCT 15', status: 'pending' },
  { id: 2, name: 'Water Authority', amount: 64.00, date: 'OCT 18', status: 'pending' },
  { id: 3, name: 'Data Link', amount: 85.00, date: 'OCT 21', status: 'pending' },
  { id: 4, name: 'Habitat Lease', amount: 1500.00, date: 'NOV 01', status: 'pending' },
  { id: 5, name: 'Transport Ins.', amount: 110.00, date: 'NOV 05', status: 'pending' },
];

export const mockTransactions = [
  { id: 1, merchant: 'Sector 4 SuperMart', amount: -85.20, category: 'Groceries', date: '2023-10-12', time: '14:32' },
  { id: 2, merchant: 'Energy Station Alpha', amount: -40.00, category: 'Fuel', date: '2023-10-11', time: '09:15' },
  { id: 3, merchant: 'Monthly Allocation', amount: 3200.00, category: 'Income', date: '2023-10-01', time: '00:00' },
  { id: 4, merchant: 'Data Link Auto-Pay', amount: -85.00, category: 'Utilities', date: '2023-09-21', time: '02:00' },
  { id: 5, merchant: 'Neon Diner', amount: -32.50, category: 'Recreation', date: '2023-09-19', time: '20:45' },
];

export const savingsGoals = [
  { id: 1, name: 'Emergency Reserve', saved: 5400, target: 10000, deadline: '2024-12-31' },
  { id: 2, name: 'Off-World Vacation', saved: 1200, target: 5000, deadline: '2024-08-15' },
  { id: 3, name: 'New Cyber-Rig', saved: 850, target: 1200, deadline: '2024-02-01' },
];